import type { ICampaignProduct } from '~/modules/campaign-product';
import type { VariantInfo } from '~/modules/campaign/types';
import type { IThemePage } from '~/stores/themePage';
import type { Campaign } from '~/types/graphql';

import { mapThemePageInfo, sortByConditions } from '~/utils';
import { parseVariantBadge } from '~/presentation/common';
import { useMemo } from 'react';

export const useCampaignTemplateVariantInfo = (
  campaign: Campaign | ICampaignProduct,
  themePages?: IThemePage[],
) => {
  return useMemo<VariantInfo[] | undefined>(() => {
    const dataVariants = campaign.variants?.map((variant) => {
      const themePageInfo = mapThemePageInfo(variant?.templateSuffix, themePages);

      return {
        ...variant,
        id: variant?.id ?? '',
        badge: parseVariantBadge(variant),
        templateSuffix: variant?.templateSuffix ?? '',
        themePageInfo,
      };
    });

    return dataVariants ? sortByConditions(dataVariants, [{ attr: 'isOrigin' }]) : undefined;
  }, [campaign.variants, themePages]);
};
